import { render, staticRenderFns } from "./PreordersReact.vue?vue&type=template&id=249ce89f&"
import script from "./PreordersReact.vue?vue&type=script&lang=js&"
export * from "./PreordersReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports